import React from 'react';
import { Chip } from '@mui/material';
import type { ApplicationState, StatusColor, WaitingOn } from '../types/billing';

interface StatusChipProps {
  state: ApplicationState;
  waitingOn?: WaitingOn;
  color: StatusColor;
  size?: 'small' | 'medium';
}

const COLOR_STYLES: Record<StatusColor, { bg: string; fg: string }> = {
  green: { bg: '#e8f5e9', fg: '#1b5e20' },
  yellow: { bg: '#fff8e1', fg: '#8d6e00' },
  orange: { bg: '#fff3e0', fg: '#bf5b00' },
  blue: { bg: '#e3f2fd', fg: '#0d47a1' },
  red: { bg: '#ffebee', fg: '#b71c1c' },
  gray: { bg: '#f5f5f5', fg: '#424242' },
};

const STATE_LABELS: Record<ApplicationState, string> = {
  DRAFT: 'Draft',
  ACTION_REQUIRED: 'Action required',
  SUBMITTED: 'Submitted',
  APPROVED: 'Approved',
  DENIED: 'Denied',
  NON_RESPONSIVE: 'Non-responsive',
  CLOSED: 'Closed',
  CLOSED_NETWORK: 'Closed network',
};

const WAITING_LABELS: Partial<Record<WaitingOn, string>> = {
  PROVIDER: 'waiting on provider',
  PAYER: 'waiting on payer',
};

export const StatusChip: React.FC<StatusChipProps> = ({ state, waitingOn, color, size = 'small' }) => {
  const styles = COLOR_STYLES[color] ?? COLOR_STYLES.gray;
  const baseLabel = STATE_LABELS[state] ?? state;
  const waitingLabel = waitingOn && WAITING_LABELS[waitingOn];
  const label = waitingLabel ? `${baseLabel} · ${waitingLabel}` : baseLabel;

  return (
    <Chip
      label={label}
      size={size}
      sx={{
        backgroundColor: styles.bg,
        color: styles.fg,
        fontWeight: 600,
        border: `1px solid ${styles.fg}22`,
      }}
    />
  );
};
